import Entity from "../entity";

export default class Bot extends Entity<number> {
  bot: string;
  status: boolean;


}
